import React, { Component } from 'react';
import {ButtonGroup, Button} from 'react-bootstrap';

class FormSort extends Component {

   /*****************************************/
   /* FUNCTION */
   /*****************************************/
   returnButtonStyle(check) {
      return (this.props.sortInfo[0] === check) ? "success" : "info"
   }

   returnArrowOrder(check) {
      if(this.props.sortInfo[0] === check) {
         switch(this.props.sortInfo[1]) {
            case "desc":
            return "fa fa-sort-desc"
            break
            case "asc":
            return "fa fa-sort-asc"
            break
            default:
            return "fa fa-sort"
         }
      } else {
         return "fa fa-sort"
      }
   }

   /*****************************************/
   /* HANDLE */
   /*****************************************/
   handleSortCLick(sort) {this.props.onSort(sort)}

   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {

      return (
         <ButtonGroup>
            <Button bsStyle={this.returnButtonStyle("prix")}
               onClick={this.handleSortCLick.bind(this, 'prix')}><i className={this.returnArrowOrder("prix")}></i> Prix</Button>
            <Button bsStyle={this.returnButtonStyle("poids")}
               onClick={this.handleSortCLick.bind(this, 'poids')}><i className={this.returnArrowOrder("poids")}></i> Poids</Button>
         </ButtonGroup>
      )
   }
}

export default FormSort;



// WEBPACK FOOTER //
// ./src/FormSort.js